"use strict";exports.isIp=function(t){return Boolean(t.match(/^(?!0)(?!.*\.$)((1?\d?\d|25[0-5]|2[0-4]\d)(\.|$)){4}$/))};
//# sourceMappingURL=isIp.cjs.map
